import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { DataFichaRegistro, FichaRegistro, FichasRegistroBienesCulturales } from 'app/models/fichaRegistro.model';
import { FormTypeWidgetComponent } from 'app/modules/GlobalComponents/id-formulario-widget.component';
import { StatusStickerComponent } from 'app/modules/GlobalComponents/status sticker.component';
import { Subject, takeUntil } from 'rxjs';
import { SearchService } from '../search.service';
import { SearchParams } from '../search-params';
import { environment as env } from 'environments/environments';

@Component({
    selector: 'card-bienes-culturales',
    templateUrl: 'card-bienes.component.html',
    imports:[
        CommonModule,
        MatTableModule,
        MatPaginatorModule,
        MatIconModule,
        MatButtonModule,

        //global componets
        StatusStickerComponent
        
    ]
})

export class CardBienesCulturalesComponent implements OnInit {
    @Input() ficha: FichasRegistroBienesCulturales
    
    displayedColumns: string[] = ['avatar','detalleSolicitud', 'tipoBien','seccion','actions'];
    //Paginación
    tipoPaginacion:number=env.TIPOLOGIA_ID_BIENES_CULTURALES
    @ViewChild(MatPaginator) paginator: MatPaginator;
    pageSizes = 10
    inicio:number = 0
    max:number = 10
    

    _unsubscribe: Subject<any> = new Subject()
    value:string =  ''

    constructor(private router: Router, private activeroute: ActivatedRoute, private SearchService: SearchService) {
        
        this.activeroute.params.pipe(takeUntil(this._unsubscribe)).subscribe(params => {
                  if (params.value) {
                    this.value = params.value;
                  }
                });
    }

    ngOnInit() { }

    openDetails(bienCulturalUuid: string){
        this.router.navigateByUrl(`/bienes-culturales/detalle/${bienCulturalUuid}`)
    }


    ngAfterViewInit() {
        this.paginator.page
            .pipe(takeUntil(this._unsubscribe))
            .subscribe(event => {
                const startIndex = event.pageIndex * event.pageSize;
                const endIndex = startIndex + event.pageSize;
                this.inicio = startIndex;
                this.max = endIndex;
                this.search(this.tipoPaginacion, this.inicio, this.max);
            });
    }


    search(tipoPaginacion: number, inicio: number, max: number) {
            let params: SearchParams = {
                tipoPaginacion: tipoPaginacion,
                inicio: inicio,
                max: max,
                asc: false,
                busqueda: this.value
            };
        
            this.SearchService.searchTask(params)
        
        }
        
    ngOnDestroy() {
        this._unsubscribe.next(null);
        this._unsubscribe.complete();
    }
}